import React from 'react';
import { useAuth } from '../contexts/auth';
import { Navigate, useLocation } from 'react-router-dom';
import {UserRole} from "../types/users";
import DefaultRoute from "./DefaultRoutes";

interface RoleProtectedRouteProps {
    element: React.FunctionComponentElement<any>;
    roles: UserRole[]
}

const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({element, roles}) => {
    const { isAuthenticated, checkUserRoles } = useAuth();

    const isRoleComplaint = checkUserRoles(roles)

    return isAuthenticated && isRoleComplaint ? element : <DefaultRoute/>
};

export default RoleProtectedRoute;